import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { DEFAULT_STAGE_COLORS } from '../constants';

export const StageDialog = ({ 
  open, 
  onOpenChange, 
  stageDialog,
  newStage, 
  setNewStage, 
  onSubmit 
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => {
      if (!o) {
        onOpenChange({ open: false, stage: null, isEdit: false });
        setNewStage({ name: '', color: '#3b82f6', is_win_stage: false, is_lost_stage: false });
      }
    }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{stageDialog.isEdit ? 'Edit Stage' : 'Add New Stage'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>Stage Name *</Label>
            <Input 
              value={newStage.name}
              onChange={(e) => setNewStage({...newStage, name: e.target.value})}
              placeholder="e.g., Qualification"
            />
          </div>
          <div className="space-y-2">
            <Label>Color</Label>
            <div className="flex gap-2 flex-wrap">
              {DEFAULT_STAGE_COLORS.map(color => (
                <button
                  key={color}
                  className={`w-8 h-8 rounded-full border-2 ${newStage.color === color ? 'border-black' : 'border-transparent'}`}
                  style={{ backgroundColor: color }}
                  onClick={() => setNewStage({...newStage, color})}
                />
              ))}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <Label>Win Stage (e.g., Booked)</Label>
            <Switch 
              checked={newStage.is_win_stage}
              onCheckedChange={(checked) => setNewStage({...newStage, is_win_stage: checked, is_lost_stage: checked ? false : newStage.is_lost_stage})}
            />
          </div>
          <div className="flex items-center justify-between">
            <Label>Lost Stage</Label>
            <Switch 
              checked={newStage.is_lost_stage}
              onCheckedChange={(checked) => setNewStage({...newStage, is_lost_stage: checked, is_win_stage: checked ? false : newStage.is_win_stage})}
            />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange({ open: false, stage: null, isEdit: false })}>Cancel</Button>
          <Button onClick={onSubmit}>{stageDialog.isEdit ? 'Update' : 'Add'} Stage</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
